module.exports = __webpack_public_path__ + "static/img/spring_my_message_icon_act.e402006.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/newVersion/spring_my_message_icon_act.png
// module id = 355
// module chunks = 32